import { isEolMoment } from 'utils/constants';
import { formatEolPhaseDisplayTitle } from 'utils/eolPhaseTitlePrefix';
import { getRtmPhasedTitleParts } from 'utils/rtmPhaseDisplayTitle';
import type { MonthlyTimelineItem } from './types';

/** Display title for monthly inline cards — EOL and phased PCO prefixes match quarterly view. */
export function formatMonthlyItemDisplayTitle(
  item: Pick<
    MonthlyTimelineItem,
    | 'title'
    | 'projectType'
    | 'type'
    | 'releasePhase'
    | 'releasePhaseId'
    | 'releasePhases'
  >
): string {
  const title = item.title || 'Untitled';
  const projectType = item.projectType || item.type;

  if (isEolMoment(projectType)) {
    return formatEolPhaseDisplayTitle(item.releasePhase, title);
  }

  return getRtmPhasedTitleParts({
    momentType: projectType,
    rawTitle: title,
    releasePhase: item.releasePhase,
    releasePhaseId: item.releasePhaseId,
    releasePhases: Array.isArray(item.releasePhases) ? item.releasePhases : null
  }).displayTitle;
}
